/**
 * 动态API配置文件
 * 基于菜单配置的API映射表
 */

// API配置映射表
const apiConfig = {
  // 案源管理相关API
  cases: {
    // 案源报备列表
    caseReportList: '/api/user/cases/index',
    // 待审批列表
    pendingApprovalList: '/api/user/cases/lists',
    // 待接案列表
    takeList: '/api/user/cases/jleanlist',
    // 添加案源
    addCase: '/api/user/cases/add',
    // 查看案源
    viewCase: '/api/user/cases/view',
    // 流程审批
    flowCheck: '/api/user/cases/flow_check',
    // 审批操作
    shenpi: '/api/user/cases/shenpi',
    // 分配操作
    fenpei: '/api/user/cases/fenpei',
    // 总计列表
    zongjilist: '/api/user/cases/zongjilist',
    // 流程列表
    flowList: '/api/user/flow/index',
    // 流程用户
    flowUsers: '/api/common/get_flow_users',
    // 编辑案源
    editCase: '/api/user/cases/edit',
    // 删除案源
    deleteCase: '/api/user/cases/delete',
    // 添加审批
    addApproval: '/api/user/cases/add_ag',
    // 审批列表
    approvalList: '/api/user/cases/ag_lists',
    // 审批详情
    approvalView: '/api/user/cases/ag_view',
    // universal approval
    universalApproval: '/api/flow_check_data/check'
  },

  // 案管中心相关API
  ajgl: {
    // 待审批列表
    pendingApprovalList: '/api/user/cases/ag_lists',
    // 接案总计
    takeTotalList: '/api/user/cases/zongjilist',
    // 审批详情
    approvalView: '/api/user/cases/ag_view'
  },

  // 案件管理相关API
  caseManagement: {
    // 诉前在办列表
    beforeLitigationList: '/api/user/sqzb/index',
    // 添加方案
    addPlan: '/api/user/sqzb/add_fangan',
    // 查看方案
    viewPlan: '/api/user/sqzb/info_fangan',
    // 编辑方案
    editPlan: '/api/user/sqzb/edit_fangan',
    // 审批方案
    approvePlan: '/api/user/sqzb/shenpi',
    // 添加异常报告
    addReport: '/api/user/sqzb/add_report',
    // 查看异常报告
    viewReport: '/api/user/sqzb/info_report',
    // 编辑异常报告
    editReport: '/api/user/sqzb/edit_report',
    // 流程审批2
    flowCheck2: '/api/user/cases/flow_check2',
    // 审批方案策划
    approvePlanScheme: '/api/user/sqzb/shenpi_fangan',
    // 添加诉讼在办
    addLitigation: '/api/user/sszb/add',
    // 编辑诉讼在办
    editLitigation: '/api/user/sszb/edit',
    // 添加传票
    addSummons: '/api/user/sszb/add_chuanpiao',
    // 传票列表
    summonsList: '/api/user/sszb/chuanpiao_list',
    // 添加案件记录
    addCaseRecord: '/api/user/sszb/add_genzong',
    // 案件记录列表
    caseRecordList: '/api/user/sszb/genzong_list',
    // 添加退案申请
    addWithdrawApplication: '/api/user/sszb/add_tuian',
    // 退案申请审批
    approveWithdrawApplication: '/api/user/sszb/shenpi_tuian',
    // 退案申请列表
    withdrawApplicationList: '/api/user/sszb/tuian_list',
    // 退案详情
    withdrawDetail: '/api/user/sszb/tuian_info',
    // 审批退案
    approveWithdraw: '/api/user/sszb/flow_check_tuian',
    // 执行准备列表
    executionPreparationList: '/api/user/zxzb/zxzb_list',
    // 退案流程列表
    withdrawFlowList: '/api/user/sszsb/flow_list',
    // 策划方案发起审批类型
    initiateApproval: '/api/user/sqzb/shenpi'
  },

  // 公共API
  common: {
    // 行业数据
    industry: '/api/common/industry',
    // 案件类型
    caseType: '/api/common/getcasetype',
    // 组织数据
    group: '/api/common/getgroup',
    // 部门数据
    department: '/api/common/department',
    // 职位列表
    positionList: '/api/common/positionlist',
    // 工作列表
    jobList: '/api/common/joblist',
    // 案源类型
    caseSource: '/api/common/getsourcetype',
    // 人员列表
    personList: '/api/common/getpersonlist',
    // 委托人列表
    clientList: '/api/common/get_custom_list',
    // 公司列表
    companyList: '/api/common/get_company_list',
    // 流程用户
    flowUsers: '/api/common/get_flow_users'
  },

  // 首页API
  home: {
    // 初始化数据
    initData: '/api/user/data/initdata',
    // 获取未读消息
    getUnread: '/api/user/data/get_no_read',
    // 设置已读
    setRead: '/api/user/data/set_read',
    // 待审批列表
    pendingApprovalList: '/api/user/data/pendingApprovalList'
  },

  // 客户管理API
  clientele: {
    // 客户列表
    index: '/api/user/customer/index',
    // 添加客户
    add: '/api/user/customer/add',
    // 编辑客户
    edit: '/api/user/customer/edit',
    // 删除客户
    delete: '/api/user/customer/delete',
    // 客户详情
    view: '/api/user/customer/view'
  },

  // 财务管理API
  finance: {
    // 应收监管表
    receivables: '/api/user/finance/receivables',
    // 办公费用垫付表
    advance: '/api/user/finance/advance',
    // 借支申请单
    borrow: '/api/user/finance/borrow',
    // 支出证明单
    expenditure: '/api/user/finance/expenditure',
    // 报销管理
    reimbursement: '/api/user/finance/reimbursement',
    // 发票管理
    invoice: '/api/user/finance/invoice',
    // 自有案件
    selfOwned: '/api/user/finance/self_owned',
    // 结案收款
    proceeds: '/api/user/finance/proceeds',
    // 结案归档
    file: '/api/user/finance/file',
    // 退案列表
    sendback: '/api/user/finance/sendback'
  },

  // 人事管理API
  personnel: {
    // 在职管理
    jobManagement: '/api/personnel/job_management',
    // 离职管理
    dimissionManagement: '/api/personnel/dimission_management',
    // 考勤
    attendance: '/api/personnel/attendance',
    // 请假
    leave: '/api/personnel/leave',
    // 薪资
    salary: '/api/personnel/salary',
    // 职位
    position: '/api/personnel/position',
    // 出差
    trip: '/api/personnel/trip'
  },

  // 系统管理API
  system: {
    // 管理员账户
    admin: '/api/user/system/admin',
    // 员工账号
    person: '/api/user/system/person',
    // 客户账号
    customer: '/api/user/system/customer',
    // 操作日志
    logs: '/api/user/log/index',
    // 角色管理
    role: '/api/user/system/role',
    // 部门管理
    department: '/api/user/system/department_index',
    // 岗位职称
    position: '/api/user/system/position',
    // 行业管理
    industry: '/api/user/system/industry',
    // 案件类型
    caseType: '/api/user/system/case_type',
    // 案源类型
    caseSource: '/api/user/system/case_source',
    // 审批流程
    approvalProcess: '/api/user/system/approval_process',
    // 功能节点
    jobRank: '/api/user/rule/index',
    // 权限管理
    permissions: '/api/user/system/permissions'
  },

  // 自有案件相关API
  selfOwned: {
    // 添加自有案件
    addCase: '/api/user/ziyou_case/add',
    // 自有案件列表
    caseList: '/api/user/ziyou_case/index',
    // 自有案件详情
    caseInfo: '/api/user/ziyou_case/info',
    // 修改自有案件
    editCase: '/api/user/ziyou_case/edit',
    // 添加结案
    addClosing: '/api/user/ziyou_case/add_jiean',
    // 结案列表
    closingList: '/api/user/ziyou_case/index_guidang',
    // 结案详情
    closingInfo: '/api/user/ziyou_case/jiean_info',
    // 修改结案
    editClosing: '/api/user/ziyou_case/edit_jiean'
  },

  // 导出相关API
  export: {
    // 客户导出
    customer: '/api/user/export/customer',
    // 案源导出
    cases: '/api/user/export/cases',
    // 案源列表导出
    casesLists: '/api/user/export/cases_lists',
    // 审批列表导出
    approvalLists: '/api/user/export/cases_ag_lists',
    // 办公费用垫付表导出
    officeAdvance: '/api/user/export/bgfydf_list',
    // 证据列表导出
    evidenceList: '/api/user/export/zhengju_list',
    // 资产验证列表导出
    assetVerification: '/api/user/export/zichan_yz_list',
    // 总计列表导出
    totalList: '/api/user/export/zongjilist',
    // 诉前在办导出
    beforeLitigation: '/api/user/export/sqzb_index',
    // 诉讼在办导出
    litigation: '/api/user/export/sszb_index',
    // 案件异常列表导出
    caseException: '/api/user/export/case_yichanglist',
    // 执行准备导出
    executionPrep: '/api/user/export/zxzb_list',
    // 执行在办导出
    execution: '/api/user/export/zhixingzb_list',
    // 异常列表导出
    exceptionList: '/api/user/export/yichanglist',
    // 监管列表导出
    supervisionList: '/api/user/export/jianguan_list',
    // 借出列表导出
    loanList: '/api/user/export/jiechu_list',
    // 支出列表导出
    expenseList: '/api/user/export/zhichu_list',
    // 报销列表导出
    reimbursementList: '/api/user/export/baoxiao_list',
    // 发票列表导出
    invoiceList: '/api/user/export/fapiao_list',
    // 退案列表导出
    withdrawList: '/api/user/export/tuian_list',
    // 自有案件列表导出
    selfOwnedCaseList: '/api/user/export/ziyou_case_list',
    // 自有案件归档导出
    selfOwnedCaseArchive: '/api/user/export/ziyou_case_guidang'
  },

  // 财务管理相关API（扩展）
  financeExtended: {
    // 应收监管列表
    supervisionList: '/api/user/finance/jianguan_list',
    // 添加应收监管
    addSupervision: '/api/user/finance/add_finance_jianguan',
    // 应收监管详情
    supervisionInfo: '/api/user/finance/jianguan_info',
    // 修改应收监管
    editSupervision: '/api/user/finance/edit_finance_jianguan',
    // 文书列表
    documentList: '/api/user/finance/get_wenshu_list',
    // 文书详情
    documentInfo: '/api/user/sszb/info_wenshu',
    // 案源案号列表
    caseNumberList: '/api/user/finance/get_all_caselist',
    // 垫付费用
    addAdvanceFee: '/api/user/finance/add_bgfydf',
    // 垫付费用列表
    advanceFeeList: '/api/user/finance/bgfydf_list',
    // 垫付费用详情
    advanceFeeInfo: '/api/user/finance/bgfydf_info',
    // 修改垫付费用
    editAdvanceFee: '/api/user/finance/edit_bgfydf',
    // 借支申请单
    addLoanApplication: '/api/user/finance/add_jiechu',
    // 借支列表
    loanList: '/api/user/finance/jiechu_list',
    // 借支详情
    loanInfo: '/api/user/finance/jiechu_info',
    // 修改借支
    editLoan: '/api/user/finance/edit_jiechu',
    // 支出证明单
    addExpenseProof: '/api/user/finance/add_zhichu',
    // 支出证明列表
    expenseProofList: '/api/user/finance/zhichu_list',
    // 支出证明详情
    expenseProofInfo: '/api/user/finance/zhichu_info',
    // 修改支出证明
    editExpenseProof: '/api/user/finance/edit_zhichu',
    // 报销
    addReimbursement: '/api/user/finance/add_baoxiao',
    // 应收监管数据
    supervisionData: '/api/user/finance/get_wenshu_info',
    // 支出证明审批列表
    expenseProofFlowList: '/api/user/finance/flow_list',
    // 报销列表
    reimbursementList: '/api/user/finance/baoxiao_list',
    // 报销详情
    reimbursementInfo: '/api/user/finance/baoxiao_info',
    // 修改报销
    editReimbursement: '/api/user/finance/edit_baoxiao',
    // 发票管理
    addInvoice: '/api/user/finance/add_fapiao',
    // 发票列表
    invoiceList: '/api/user/finance/fapiao_list',
    // 发票详情
    invoiceInfo: '/api/user/finance/fapiao_info',
    // 修改发票
    editInvoice: '/api/user/finance/edit_fapiao',
    // 应收账款
    addReceivable: '/api/user/finance/add_yingshou',
    // 应收账款详情
    receivableInfo: '/api/user/finance/yingshou_info',
    // 修改应收账款
    editReceivable: '/api/user/finance/edit_yingshou',
    // 应收账款列表
    receivableList: '/api/user/finance/yingshou_list',
    // 结案归档
    addClosingArchive: '/api/user/finance/add_guidang',
    // 归档列表
    archiveList: '/api/user/finance/guidang_list',
    // 归档详情
    archiveInfo: '/api/user/finance/guidang_info',
    // 修改归档
    editArchive: '/api/user/finance/edit_guidang',
    // 财务流程列表
    financeFlowList: '/api/user/finance/caiwu_flow_list'
  },

  // 执行准备相关API
  executionPrep: {
    // 添加执行准备
    addExecutionPrep: '/api/user/zxzb/add_zxzb',
    // 执行在办列表
    executionList: '/api/user/zxzb/zhixingzb_list',
    // 执行流程列表
    flowList: '/api/user/zxzb/flow_list',
    // add execution
    addExecution: '/api/user/zxzb/add_zxzb',
    // 修改执行准备
    editExecutionPrep: '/api/user/zxzb/edit_zxzb',
    // 添加报告
    addReport: '/api/user/zxzb/add_report',
    // 异常案件列表
    exceptionList: '/api/user/zxzb/yichanglist',
    // 异常报告详情
    exceptionReportInfo: '/api/user/zxzb/info_report',
    // 修改异常报告
    editExceptionReport: '/api/user/zxzb/edit_report',
    // 分配律师
    assignLawyer: '/api/user/zxzb/fenpei_lvshi',
    // 结案内容
    closingContent: '/api/user/zxzb/jiean_info'
  },

  // 房地产相关API
  realEstate: {
    // 添加房地产
    addRealEstate: '/api/user/company/add',
    // 房地产列表
    realEstateList: '/api/user/company/index',
    // 房地产详情
    realEstateInfo: '/api/user/company/info',
    // 修改房地产
    editRealEstate: '/api/user/company/edit'
  },

  // 人事管理相关API（扩展）
  personnelExtended: {
    // 员工列表
    personList: '/api/user/hr/person_list',
    // 员工信息
    personInfo: '/api/user/hr/person_info',
    // 编辑员工
    editPerson: '/api/user/hr/edit_person',
    // 请假类型列表
    leaveTypeList: '/api/common/get_qingjia_type_list',
    // 添加请假
    addLeave: '/api/user/hr/add_qingjia',
    // 请假列表
    leaveList: '/api/user/hr/qingjia_list',
    // 请假信息
    leaveInfo: '/api/user/hr/qingjia_info',
    // 添加调薪
    addSalaryAdjustment: '/api/user/hr/add_tiaoxin',
    // 调薪列表
    salaryAdjustmentList: '/api/user/hr/tiaoxin_list',
    // 调薪信息
    salaryAdjustmentInfo: '/api/user/hr/tiaoxin_info',
    // 添加调岗
    addPositionChange: '/api/user/hr/add_tiaogang',
    // 调岗列表
    positionChangeList: '/api/user/hr/tiaogang_list',
    // 调岗信息
    positionChangeInfo: '/api/user/hr/tiaogang_info',
    // 添加出差
    addBusinessTrip: '/api/user/hr/add_chuchai',
    // 出差列表
    businessTripList: '/api/user/hr/chuchai_list',
    // 出差信息
    businessTripInfo: '/api/user/hr/chuchai_info',
    // 添加离职申请
    addResignation: '/api/user/hr/add_lizhi',
    // 离职列表
    resignationList: '/api/user/hr/lizhi_list',
    // 离职信息
    resignationInfo: '/api/user/hr/lizhi_info'
  },

  // 诉讼在办相关API
  litigation: {
    // 诉讼在办列表
    litigationList: '/api/user/sszb/index',
    // 诉讼在办详情
    litigationInfo: '/api/user/sszb/info',
    // 添加文书结案
    addDocumentClosing: '/api/user/sszb/add_wenshu',
    // 编辑文书结案
    editDocumentClosing: '/api/user/sszb/edit_wenshu',
    // 文书结案信息
    documentClosingInfo: '/api/user/sszb/info_wenshu',
    // 添加案件异常报告
    addCaseReport: '/api/user/sszb/add_report',
    // 编辑异常报告
    editCaseReport: '/api/user/sszb/edit_report',
    // 案件异常报告信息
    caseReportInfo: '/api/user/sszb/info_report',
    // 流程用户
    flowUsers: '/api/user/sszb/flow_list',
    // 诉前在办流程列表
    flowList: '/api/user/cases/flow_list',
    // 添加执行结案
    addExecutionClosing: '/api/user/zxzb/add_jiean',
    // 编辑执行结案
    editExecutionClosing: '/api/user/zxzb/edit_jiean',
    // 执行结案信息
    executionClosingInfo: '/api/user/zxzb/jiean_info'
  },

  // 系统管理相关API（扩展）
  systemExtended: {
    // 部门索引
    departmentIndex: '/api/user/system/department_index',
    // 添加部门
    departmentAdd: '/api/user/system/department_add',
    // 编辑部门
    departmentEdit: '/api/user/system/department_edit',
    // 删除部门
    departmentDelete: '/api/user/system/department_delete',
    // 岗位索引
    positionIndex: '/api/user/position/index',
    // 添加岗位
    positionAdd: '/api/user/position/add',
    // 编辑岗位
    positionEdit: '/api/user/position/edit',
    // 删除岗位
    positionDelete: '/api/user/position/delete',
    // 管理员列表
    adminList: '/api/user/admin/index',
    // 添加管理员
    adminAdd: '/api/user/admin/add',
    // 编辑管理员
    adminEdit: '/api/user/admin/edit',
    // 编辑管理员密码
    adminEditPwd: '/api/user/admin/edit_pwd',
    // 删除管理员
    adminDelete: '/api/user/admin/delete'
  },

  // 标签页相关API
  tabs: {
    // 获取顶部菜单
    headerMenu: '/api/user/data/topmenu',
    // 获取左侧菜单
    asideMenu: '/api/user/data/leftmenu',
    // 获取标签页数据
    getTabData: '/api/user/tabs/get_tab_data',
    // 更新标签页
    updateTab: '/api/user/tabs/update_tab',
    // 删除标签页
    deleteTab: '/api/user/tabs/delete_tab'
  },

  // 用户相关API
  user: {
    // 用户登录
    login: '/api/login',
    // 获取用户信息
    userInfo: '/api/user/get_user_info',
    // 用户列表
    userList: '/api/user/user/list',
    // 编辑用户
    editUser: '/api/user/user/edit',
    // 删除用户
    deleteUser: '/api/user/user/delete',
    // 用户权限
    userPermissions: '/api/user/user/permissions'
  },

  // 异常相关API
  exception: {
    // 异常案件列表
    exceptionList: '/api/user/sszb/case_yichanglist',
    // 异常列表
    exceptionListGeneral: '/api/user/exception/list',
    // 异常详情
    exceptionInfo: '/api/user/exception/info',
    // 添加异常
    addException: '/api/user/exception/add',
    // 编辑异常
    editException: '/api/user/exception/edit',
    // 删除异常
    deleteException: '/api/user/exception/delete'
  },

  // 综合管理相关API
  comprehensive: {
    // 添加工作任务
    addWorkTask: '/api/user/zonghe/add_tasks',
    // 工作任务列表
    workTaskList: '/api/user/zonghe/tasks_index',
    // 工作任务信息
    workTaskInfo: '/api/user/zonghe/tasks_info',
    // 添加日报总结
    addDailyReport: '/api/user/zonghe/add_ribao',
    // 表单管理
    formManagement: '/api/zhonghe/form_management',
    // 学习培训
    learningTraining: '/api/zhonghe/learning_training',
    // 制度文件
    systemDocument: '/api/zhonghe/system_document',
    // 处罚通知
    punishmentNotice: '/api/zhonghe/punishment_notice',
    // 证据领用
    evidenceBorrowing: '/api/zhonghe/evidence_borrowing',
    // 快递收发
    expressDelivery: '/api/zhonghe/express_delivery',
    // 资产管理
    assetManagement: '/api/zhonghe/asset_management',
    // 证章申领
    badgeApplication: '/api/zhonghe/badge_application',
    // 手续费用申领
    procedureFeeApplication: '/api/zhonghe/procedure_fee_application'
  }
}

/**
 * 根据模块和API名称获取API URL
 * @param {string} module - 模块名称
 * @param {string} apiName - API名称
 * @returns {string} API URL
 */
export const getApiUrl = (module, apiName) => {
  if (!apiConfig[module]) {
    console.warn(`API模块 "${module}" 不存在`)
    return ''
  }
  
  if (!apiConfig[module][apiName]) {
    console.warn(`API "${apiName}" 在模块 "${module}" 中不存在`)
    return ''
  }
  
  return apiConfig[module][apiName]
}

/**
 * 获取模块下的所有API配置
 * @param {string} module - 模块名称
 * @returns {object} 模块API配置
 */
export const getModuleApis = (module) => {
  return apiConfig[module] || {}
}

/**
 * 获取所有API配置
 * @returns {object} 所有API配置
 */
export const getAllApis = () => {
  return apiConfig
}

/**
 * 动态添加API配置
 * @param {string} module - 模块名称
 * @param {string} apiName - API名称
 * @param {string} url - API URL
 */
export const addApiConfig = (module, apiName, url) => {
  if (!apiConfig[module]) {
    apiConfig[module] = {}
  }
  apiConfig[module][apiName] = url
}

/**
 * 批量添加API配置
 * @param {object} configs - API配置对象
 */
export const addBatchApiConfig = (configs) => {
  Object.keys(configs).forEach(module => {
    if (!apiConfig[module]) {
      apiConfig[module] = {}
    }
    Object.assign(apiConfig[module], configs[module])
  })
}

export default apiConfig
